export class LateralMenuParams {
    openSelector: boolean;
    insuranceCoreNameByUser: string;
}
